<script setup lang="ts">
const { t } = useI18n()

const emit = defineEmits<{
  (e: 'close'): void
}>()

const menuItems = [
  {
    label: t('journal.title'),
    icon: 'i-mingcute-diary-line',
    to: '/journal'
  },
  {
    label: t('notes.title'),
    icon: 'i-mingcute-sticker-line',
    to: '/notes'
  },
  {
    label: t('lists.title'),
    icon: 'i-mingcute-list-check-line',
    to: '/lists'
  },
  {
    label: t('tasks.title'),
    icon: 'i-mingcute-checkbox-line',
    to: '/tasks'
  }
]

function handleClose() {
  emit('close')
}
</script>

<template>
  <section class="space-y-4">
    <div class="space-y-2">
      <NuxtLink
        v-for="item in menuItems"
        :key="item.to"
        :to="item.to"
        size="xl"
        exact-active-class="text-primary"
        class="flex items-center gap-2 p-2 rounded-3xl font-bold transition-all duration-300"
        @click="handleClose"
      >
        <UIcon :name="item.icon" size="24" />
        <span>{{ item.label }}</span>
      </NuxtLink>
    </div>
    <USeparator />
    <NuxtLink
      to="/settings"
      size="xl"
      class="flex items-center gap-2 rounded-3xl p-2 font-bold transition-all duration-300"
      @click="handleClose"
    >
      <UIcon name="i-mingcute-settings-3-line" size="24" />
      <span>{{ $t('settings.title') }}</span>
    </NuxtLink>
  </section>
</template>
